"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreWebSocket = exports.STAGE_WEB_SOCKET_URL = exports.WEB_SOCKET_URL = void 0;
var centrifuge_1 = require("centrifuge");
exports.WEB_SOCKET_URL = 'wss://ws-store.xsolla.com/connection/websocket';
exports.STAGE_WEB_SOCKET_URL = 'wss://ws-store-stage.srv.local/connection/websocket';
var StoreWebSocket = /** @class */ (function () {
    function StoreWebSocket(userInfo, disableHistoryOnConnect, connectionURL) {
        if (disableHistoryOnConnect === void 0) { disableHistoryOnConnect = false; }
        if (connectionURL === void 0) { connectionURL = exports.WEB_SOCKET_URL; }
        this.disableHistoryOnConnect = false;
        this._onclose = null;
        this._onerror = null;
        this._onmessage = null;
        this._onopen = null;
        this.client = new centrifuge_1.Centrifuge(connectionURL, {
            data: {
                user_external_id: userInfo.user_external_id,
                auth: userInfo.auth,
                project_id: userInfo.project_id
            }
        });
        this.disableHistoryOnConnect = disableHistoryOnConnect;
    }
    Object.defineProperty(StoreWebSocket.prototype, "onclose", {
        get: function () {
            return this._onclose;
        },
        set: function (handler) {
            var _this = this;
            this._onclose = handler;
            this.client && this.client.on('disconnected', function (ctx) {
                _this._onclose && _this._onclose(ctx);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreWebSocket.prototype, "onerror", {
        get: function () {
            return this._onerror;
        },
        set: function (handler) {
            var _this = this;
            this._onerror = handler;
            this.client && this.client.on('error', function (ctx) {
                _this._onerror && _this._onerror(ctx.error);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreWebSocket.prototype, "onmessage", {
        get: function () {
            return this._onmessage;
        },
        set: function (handler) {
            var _this = this;
            this._onmessage = handler;
            this.client && this.client.on('publication', function (ctx) {
                _this._onmessage && _this._onmessage(ctx.data);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StoreWebSocket.prototype, "onopen", {
        get: function () {
            return this._onopen;
        },
        set: function (handler) {
            var _this = this;
            this._onopen = handler;
            this.client && this.client.on('connected', function (ctx) {
                _this._onopen && _this._onopen(ctx.data);
            });
        },
        enumerable: false,
        configurable: true
    });
    StoreWebSocket.prototype.connect = function () {
        var _this = this;
        this.client.on('subscribed', function (ctx) {
            if (!_this.disableHistoryOnConnect) {
                // @ts-ignore
                _this.client.history(ctx.channel, { limit: -1, since: { offset: 0 }, reverse: false }).then(function (res) {
                    res.publications.forEach(function (ctx) {
                        _this._onmessage && _this._onmessage(ctx.data);
                    });
                });
            }
        });
        this.client.connect();
    };
    StoreWebSocket.prototype.close = function () {
        this.client.disconnect();
    };
    return StoreWebSocket;
}());
exports.StoreWebSocket = StoreWebSocket;
//# sourceMappingURL=store-websocket.js.map